import { giftBonus } from '@/assets/icons'
import { useTranslate } from '@/i18n/useTranslate'
import { formatPromotionTotalAmount } from '@/utilities/depositBonusHelper'

type VendorBonusAmountNoteProps = {
    vendorName: string
    bonusAmount: number
    currencyCode: string
    depositOrdinal: number
    paymentAmount: number
}

export default function VendorBonusAmountNote({
    vendorName,
    bonusAmount,
    currencyCode,
    depositOrdinal,
    paymentAmount
}: VendorBonusAmountNoteProps) {
    const { t } = useTranslate()
    const totalAmount = paymentAmount + bonusAmount

    return (
        <div className="vendor-bonus-amount-note">
            <div className="vendor-bonus-amount-note__bonus">
                <img src={giftBonus} alt="" />
                <div>
                    <strong>
                        +{formatPromotionTotalAmount(bonusAmount)} {currencyCode}
                    </strong>
                    <span>
                        {t('vendorBonusBanner.bonusOnDeposit', {
                            vendor: vendorName,
                            ordinal: depositOrdinal
                        })}
                    </span>
                </div>
            </div>
            <div className="vendor-bonus-amount-note__total">
                <span>{t('vendorBonusBanner.totalDeposit')}</span>
                <strong>
                    {formatPromotionTotalAmount(totalAmount)} {currencyCode}
                </strong>
            </div>
        </div>
    )
}
